import { createSelector } from 'reselect'

export const getFavouriteProfilesLoading = createSelector(
  state => state && state.user && state.user.profile
    && state.user.profile.favouriteProfiles
  ? state.user.profile.favouriteProfiles.isLoading : false,
 	isLoading => isLoading
)
